import { WebPatientData } from "services/types/appointments.type";
import { NEW_PATIENT_OPTION, PatientOption } from "../patient-field.component";

export default function createPatientFromWebPatientData(
  webPatient: WebPatientData
): PatientOption {
  const newPatient: PatientOption = {
    ...NEW_PATIENT_OPTION,
    first_name: webPatient.first_name,
    last_name: webPatient.last_name,
    phone: webPatient.phone,
    email: webPatient.email,
  };
  return newPatient;
}
